import { GroupIds } from "@/configuration/group-ids";
import type { CustomerSmsRoutingConfig } from "@/customer-interface/sms-routing";
import { SPORT_ORTHO_SMS_SANDBOX_LINE } from "@/packages/shared/src/group-configs/groups";
import { e164PhoneNumberSchema } from "@/shared/utils/phone-utils";

export const SPORTORTHO_TWILIO_NUMBER = "+16292803283";
export const SPORTORTHO_TRANSFER_LINE = "+16152588273";
const sandboxSmsPhoneNumber = e164PhoneNumberSchema.parse(SPORT_ORTHO_SMS_SANDBOX_LINE);

export const sportOrthoSmsRoutingConfig = {
  groups: [
    {
      groupId: GroupIds.SPORTORTHO_LIVE,
      inboundPhoneNumbers: [SPORTORTHO_TWILIO_NUMBER],
      defaultSenderPhoneNumber: SPORTORTHO_TWILIO_NUMBER,
      clinicPhone: { defaultPhoneNumber: SPORTORTHO_TRANSFER_LINE, preferReceivingLocationPhone: true },
    },
    {
      groupId: GroupIds.SPORTORTHO_LIVE_SANDBOX,
      inboundPhoneNumbers: [sandboxSmsPhoneNumber],
      defaultSenderPhoneNumber: sandboxSmsPhoneNumber,
      clinicPhone: { defaultPhoneNumber: SPORTORTHO_TRANSFER_LINE, preferReceivingLocationPhone: true },
    },
  ],
} as const satisfies CustomerSmsRoutingConfig;
